import React from 'react'
import TeamBanner from './TeamBanner'
import TeamMeet from './TeamMeet'
import BoardDirectors from './BoardDirectors'
import ManagementTeam from './ManagementTeam'
import HomeResource from '../home/HomeResource'


const boardData = [
  {
    name: "Rahul Mehra",
    role: "Chief Executive Officer (CEO)",
    img: "/assets/images/rahul-img.webp",
    description: "Rahul Mehra is the visionary CEO of Dox and Box, a leading document management and data security solutions company in India. With a strong focus on innovation, compliance, operational excellence, he has been instrumental in building Dox and Box into a trusted partner for enterprises seeking secure records management, digitization, data lifecycle solutions. Under his leadership, the company has expanded its capabilities across document storage, digitization, secure destruction, intelligent information management systems. Rahul’s strategic direction emphasizes data protection, efficiency, technology-driven transformation, enabling organizations to transition from paper-based systems to fully digital, secure ecosystems.",
    twitter:"https://x.com/Rhul_mehra",
    linkedin:"https://www.linkedin.com/authwall?trk=bf&trkInfo=AQH7I-TyyCRTIgAAAZ3X_oGQY6K_s4L8vEjrtCccMgQM-s7muUbGzuAbCWJnGr0VmzArZxtuoTJ1dyZtGkLj2n5_4sac5L7jAC_nxyFXqofsA5Wv3PPCK15N9-viZ6l_AvjY9DI=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Frahul-mehra-19132419%2F",

  },
  {
    name: "Lovely Mehra",
    role: "Director",
    img: "/assets/images/director-2.webp",
    description: "Lovely Mehra serves as Director at Dox and Box, playing a key role in organizational development, service quality, client experience. She focuses on strengthening operational frameworks and ensuring that the company delivers consistent, high-standard solutions across industries. Her leadership supports the company’s mission of reliability, compliance, customer-centric innovation.",
    twitter:"https://x.com/LvlyMehra",
    linkedin:"https://www.linkedin.com/authwall?trk=bf&trkInfo=AQHsfYh1N0swLgAAAZ3X_yWg6EipWcHMx6JEIwv0lNCCQBBDsTvx0GhAj4BdSSSfx90nu6Y7kByd0eXTPvl9J-Ow2KHG8qdY_kTVkDeWnTuwWYOrk4pE20OriBupEJ9Ia5CNRWg=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Flovely-mehra-676964206",
  }
];

const teamData = [
  {
    name: "Rituraj Pankaj",
    role: "Chief Technology Officer (CTO)",
    img: "/assets/images/rituraj.webp",
    description: "Rituraj Pankaj leads the technological vision at Dox and Box as CTO, driving the development of secure, scalable, intelligent document management systems. He oversees the integration of advanced technologies including digitization platforms, workflow automation, data security infrastructure. His expertise ensures that Dox and Box remains at the forefront of innovation in records management and enterprise information systems.",
    twitter:"https://x.com/RiturajPankaj",
    linkedin:"https://www.linkedin.com/authwall?trk=bf&trkInfo=AQEySoT54225XwAAAZ3YARHQnPx-x-mLmu6OFyAdEx5lwmyvJg0C0Ia7O72GclEb3rXMi3gWulJkhQapaHCG6SnFYE1p_Ktcma9YXlZ2ZCr3aN4RuNZ9mlo39n7Cw2exvjoFpR4=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fin%2Frituraj-pankaj-025b44206%2F",

  },
  {
    name: "Jyoti Goel",
    role: " IT Department",
    img: "/assets/images/jyoti.webp",
    description: "Jyoti Goel is a dedicated IT professional known for managing technology systems with efficiency and precision. She plays a key role in maintaining digital infrastructure, improving operational workflows, ensuring seamless technical support across teams. Her proactive approach, problem-solving mindset, commitment to innovation contribute to organizational productivity and growth.",
    twitter:"",
    linkedin:"",

  },
  {
    name: "Randeep Singh",
    role: "Operations",
    img: "/assets/images/randeep.webp",
    description: "Randeep Singh oversees operations with a strong focus on efficiency, coordination, process optimization. He ensures smooth day-to-day functioning across departments while maintaining high standards of execution and service delivery. His leadership, strategic planning abilities, hands-on management style help streamline operations, enhance productivity, support the organization’s business objectives.",
    twitter:"",
    linkedin:"",

  },
  {
    name: "Sanjay Singh",
    role: "Finance",
    img: "/assets/images/sanjay.webp",
    description: "Sanjay Singh is an experienced finance professional responsible for managing financial planning, budgeting, fiscal operations with accuracy and integrity. He monitors financial performance, ensures compliance, supports strategic decision-making through detailed analysis and reporting. His analytical expertise, disciplined approach, commitment to financial stability contribute to the organization’s growth.",
    twitter:"",
    linkedin:"",

  },
];

export default function Team() {
  return (
    <>
      <TeamBanner />
      <TeamMeet />
      <BoardDirectors boardData={boardData} />
      <ManagementTeam teamData={teamData} />
      <HomeResource />

    </>
  )
}
